import { IconProp } from "@fortawesome/fontawesome-svg-core"
import clsx from "clsx"

import { faIcon } from "@utils/faIcon"

import { SkeletonTypography } from "@particles"

import { Icon } from "@atoms"

import { useFormField } from "@molecules/Form/Form"

import styles from "./InputHelpText.module.scss"
import { BaseInputHelpTextProps, InputHelpTextProps, InputHelpTextStatus } from "./InputHelpText.types"

const ICON_SIZE = 14

const statusIcons: Record<Exclude<InputHelpTextStatus, "neutral">, IconProp> = {
    info: faIcon({ name: "circle-info", style: "regular" }),
    success: faIcon({ name: "circle-check", style: "regular" }),
    warning: faIcon({ name: "warning", style: "regular" }),
    error: faIcon({ name: "circle-xmark", style: "regular" }),
}

export function BaseInputHelpText(props: BaseInputHelpTextProps) {
    const { message, status, showIcon, neutralIcon, isLoading = false, id, className, ...rest } = props

    if (isLoading) {
        return (
            <div className={clsx(styles.base, className)} {...rest}>
                <SkeletonTypography variant="captionSM" />
            </div>
        )
    }

    return (
        <div className={clsx(styles.base, styles[`${status}Status`], className)} {...rest}>
            {showIcon && (
                <span className={styles.iconContainer}>
                    <Icon
                        icon={status === "neutral" ? neutralIcon : statusIcons[status]}
                        size={ICON_SIZE}
                        container="fixedHeight"
                    />
                </span>
            )}
            <span id={id} className={styles.text}>
                {message}
            </span>
        </div>
    )
}

function FormFieldInputHelpText(props: BaseInputHelpTextProps) {
    const { formMessageId } = useFormField()

    return <BaseInputHelpText {...props} id={formMessageId} />
}

export default function InputHelpText(props: InputHelpTextProps) {
    const { inFormField = true, ...baseProps } = props

    if (inFormField) {
        return <FormFieldInputHelpText {...baseProps} />
    } else {
        return <BaseInputHelpText {...baseProps} />
    }
}
